import { AxiosResponse } from 'axios';
import { buildAsyncThunk } from '../utils';
import { ChangelogAddEditModel, ChangelogsListFiltersRequestModel, ChangelogsListModel } from '@models/api/changelog';
import { httpClient } from '@core/http/httpClient';
import { applicationPaths } from '@core/http/applicationPaths';
import { omitAbortSignalConfig } from '@hwm/ui-lib';
import { isArray } from 'lodash';

interface GetSiteListThunk {
  filters: ChangelogsListFiltersRequestModel;
  currentPage: number;
  pageSize: number;
}

export const fetchChangelogsList = buildAsyncThunk(
  'changelogs/fetchChangelogsList',
  async ({ filters, ...restOfParams }: GetSiteListThunk) => {
    const response: AxiosResponse<ChangelogsListModel> = await httpClient.get(applicationPaths.changelogs.changelog(), {
      params: {
        ...filters,
        ...restOfParams,
      },
      paramsSerializer: (params) => {
        const serializedParams = Object.entries(params ?? {})
          ?.map(([key, val]) => (isArray(val) ? val?.map((v) => `${key}=${v}`)?.join('&') : `${key}=${val ?? ''}`))
          ?.join('&');

        return serializedParams;
      },
      signal: omitAbortSignalConfig,
    });

    return response.data;
  }
);

interface AddChangelogEntryThunk {
  data: ChangelogAddEditModel;
}

export const addChangelogEntry = buildAsyncThunk(
  'changelogs/addChangelogEntry',
  async (thunkData: AddChangelogEntryThunk) => {
    const response: AxiosResponse = await httpClient.post(applicationPaths.changelogs.changelog(), thunkData.data);
    return response.data;
  }
);

export interface EditChangelogEntryThunk extends AddChangelogEntryThunk {
  id: number;
}

export const editChangelogEntry = buildAsyncThunk(
  'changelogs/editChangelogEntry',
  async ({ id, data }: EditChangelogEntryThunk) => {
    const response: AxiosResponse = await httpClient.put(applicationPaths.changelogs.edit(id), data);
    return { ...response.data, id, data };
  }
);

interface DeleteChangelogEntryThunk {
  id: number;
}

export const deleteChangelogEntry = buildAsyncThunk(
  'changelogs/deleteChangelogEntry',
  async ({ id }: DeleteChangelogEntryThunk) => {
    const response: AxiosResponse = await httpClient.delete(applicationPaths.changelogs.edit(id));
    return response.data;
  }
);
